import './index.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createHealthApi } from './api/health-api';
import { App } from './app/App';
import { createAppServices } from './app/create-services';
import { ServicesContext } from './app/services';
import { parseWebConfig } from './config/env';
import { getDesktopBridge } from './platform/desktop';
import { createReportApi } from './report/report-api';
import { createAdminServices } from './settings/services/admin-services';
import { createAIRelayApi } from './workspace/services/ai-relay-api';
import { createQueryApi } from './workspace/services/query-api';

const config = parseWebConfig(import.meta.env);

const fetchFn = window.fetch.bind(window);
const services = createAppServices({
  healthApi: createHealthApi({ baseUrl: config.apiBaseUrl, fetch: fetchFn }),
  aiRelayApi: createAIRelayApi({ baseUrl: config.apiBaseUrl, fetch: fetchFn }),
  queryApi: createQueryApi({ baseUrl: config.apiBaseUrl, fetch: fetchFn }),
  storage: window.localStorage,
  previewLatencyMs: 150,
  // El escritorio carga la web por file:// y no tiene servidor embebido: sin configuracion.
  ...(getDesktopBridge() === null
    ? {
        admin: createAdminServices({ baseUrl: config.apiBaseUrl, fetch: fetchFn }),
        reports: createReportApi({ baseUrl: config.apiBaseUrl, fetch: fetchFn }),
      }
    : {}),
});

const container = document.getElementById('root');
if (container === null) throw new Error('No se encontro el elemento #root.');

createRoot(container).render(
  <StrictMode>
    <ServicesContext value={services}>
      <App />
    </ServicesContext>
  </StrictMode>,
);
